<div
  class="relative flex w-full items-center justify-center bg-center px-5 py-2"
  [ngClass]="{
    'h-28 max-h-28': size() === 'S',
    'h-44 max-h-44': size() === 'M',
    'h-60 max-h-60': size() === 'L',
  }"
  [class.cursor-pointer]="hasNavigableLink(backgroundUrl())"
  [ngStyle]="getBackgroundStyles()"
  [style.backgroundColor]="backgroundColor() | contentBuilderColor"
  (click)="hasNavigableLink(backgroundUrl()) && onBackgroundClick($event)"
>
  @if (displayHomeButton() || displayBackButton()) {
    <div class="absolute left-0 z-20 flex h-full items-center gap-3 pl-4">
      @if (displayBackButton()) {
        <button
          type="button"
          class="flex items-center leading-none"
          [attr.aria-label]="'kiosk-header.previous-button' | translate"
          data-testid="kiosk-header-back-button"
          (click)="goBack($event)"
        >
          <i
            class="icon icon-arrow-left"
            [style.font-size]="leaveSessionIconSize()"
            [style.color]="backButtonIconColor() | contentBuilderColor"
          ></i>
        </button>
      }
      @if (displayHomeButton()) {
        <app-button-atom
          color="primary"
          [type]="'kiosk-light'"
          [size]="size()"
          classContent="!w-auto"
          [label]="buttonHomeText() ?? 'kiosk-header.back-button' | translate"
          [overrideBgColor]="buttonBackgroundColor()"
          [overrideTextColor]="buttonTextColor()"
          (click)="redirectoToHome($event)"
        >
        </app-button-atom>
        @if (showHomeLoader()) {
          <span
            class="inline-block h-12 w-12 shrink-0 animate-spin rounded-full border-4 border-neutral-900 border-t-transparent shadow-[0_0_0_2px_white]"
            data-testid="kiosk-header-home-loader"
            role="status"
          ></span>
        }
      }
    </div>
  }
  @if (logoSrc(); as src) {
    <img
      [src]="src"
      class="w-auto object-contain"
      [ngClass]="{
        'h-1/2 max-w-[22%]': logoWidth() === 'small',
        'h-3/4 max-w-[40%]': logoWidth() === 'medium',
        'h-full max-w-[70%]': logoWidth() === 'large',
      }"
      [class.cursor-pointer]="hasNavigableLink(logoUrl())"
      (click)="hasNavigableLink(logoUrl()) && onLogoClick($event)"
    />
  }
  @if (displayAllergenFilters() || displayCurrency.isEnabled() || displayLeavingSessionButton()) {
    <div
      class="absolute right-4 z-20 flex h-full items-center gap-3"
      (click)="$event.stopPropagation()"
    >
      @if (displayAllergenFilters()) {
        <button
          type="button"
          class="inline-flex items-center gap-3 rounded-full bg-primary-600 px-6 py-3 font-base text-xl font-semibold text-white"
          [style.backgroundColor]="allergenButtonBackground()"
          [style.color]="allergenButtonText()"
          (click)="openAllergenFilters.emit()"
        >
          <i
            class="icon icon-filter"
            aria-hidden="true"
          ></i>
          <span>{{ 'catalog-filters.trigger' | translate }}</span>
          @if (allergenFilterCount() > 0) {
            <span
              class="inline-flex h-8 min-w-8 items-center justify-center rounded-full bg-white px-2 text-base font-bold text-primary-600"
              [style.color]="allergenButtonBackground()"
            >
              {{ allergenFilterCount() }}
            </span>
          }
        </button>
      }
      @if (displayCurrency.isEnabled()) {
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-full border border-neutral-800 bg-white px-5 py-3 text-xl font-semibold text-neutral-900"
          [attr.aria-label]="'kiosk.currency.modal-title' | translate"
          (click)="openCurrencyPicker($event)"
        >
          <svg
            viewBox="0 0 24 24"
            class="h-6 w-6"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            aria-hidden="true"
          >
            <circle
              cx="12"
              cy="12"
              r="9"
            />
            <path d="M3 12h18" />
            <path
              d="M12 3c2.5 2.8 3.8 5.8 3.8 9s-1.3 6.2-3.8 9c-2.5-2.8-3.8-5.8-3.8-9s1.3-6.2 3.8-9z"
            />
          </svg>
          <span>{{ currencyButtonCode() }}</span>
          @if (currencyButtonSymbol()) {
            <span>{{ currencyButtonSymbol() }}</span>
          }
          <i
            class="icon icon-arrow-down-s text-lg"
            aria-hidden="true"
          ></i>
        </button>
      }
      @if (displayLeavingSessionButton()) {
        <button
          type="button"
          class="flex h-full items-center px-4 leading-none"
          [class.animate-ping]="isLeaving()"
          (click)="leaveSession()"
        >
          <i
            class="icon icon-logout-3"
            [style.font-size]="leaveSessionIconSize()"
          ></i>
        </button>
      }
    </div>
  }
</div>
@if (headerLandingText()) {
  <p class="p-5 text-3xl font-bold">
    {{ headerLandingText() }}
  </p>
}
